"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var cashPricesStyles = styles_1.makeStyles(function (_a) {
    var typography = _a.typography;
    return ({
        priceElement: {
            fontFamily: typography.fontFamily2,
        },
        labelBefore: {
            marginBottom: 0,
            marginRight: 10,
        },
    });
}, { name: 'GqlSummary_CashPrices' });
exports.default = cashPricesStyles;
